import React from 'react';
import { useTranslation } from 'react-i18next';

import LLBrownLogo from '@assets/llicon-logo-brown.svg';
import FacebookIcon from '@assets/sns/facebook_icon.svg';
import InstagramIcon from '@assets/sns/instagram_icon.svg';
import LineIcon from '@assets/sns/line_icon.svg';

import * as styles from './styles.module.scss';

const SnsBanner: React.FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <div className={styles['sns_banner']}>
            <div>
                <p>{t('sns.p')}</p>
                <span>{t('sns.span')}</span>
                <LLBrownLogo />
                <div className={styles['sns_icons']}>
                    <a
                        href="http://instagram.com/leoandleajapan/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Instagram Sns Banner Link"
                    >
                        <InstagramIcon />
                    </a>
                    <a
                        href="https://www.facebook.com/LeoandLeaJapan/"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Facebook Sns Banner Link"
                    >
                        <FacebookIcon />
                    </a>
                    <a
                        href="https://line.me/R/ti/p/%40aoq7369a"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Line Sns Banner Link"
                    >
                        <LineIcon />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default SnsBanner;
